<template>
    <v-hover v-slot:default="{ hover }">
        <v-card>
            <v-toolbar flat v-if="marcador == 'alto'" class="blink_me_small" style="border-right-color: #f7654b; border-right-style: solid; ">
                <span :class="{'font-color-gray': hover}">{{title}}</span>
            </v-toolbar>
            <v-toolbar flat v-else-if="marcador == 'medio'" style="background: linear-gradient(to right, rgba(255, 84, 41, 0.4) 2%, rgba(16, 48, 61, 0) 22%); 
                border-right-color: #f7654b; border-right-style: solid; ">
                <span :class="{'font-color-gray': hover}">{{title}}</span>
            </v-toolbar>
            <v-toolbar flat v-else style="border-right-color: #f7654b; border-right-style: solid;">
                <span :class="{'font-color-gray': hover}">{{title}}</span>
            </v-toolbar>
            <v-list style="border-right-color: #f7654b; border-right-style: solid; ">
                <v-layout justify-center row class="display-1" v-if="mortalidade">
                    <v-flex text-xs-center justify-center style="display: -webkit-box;">
                        <v-layout  justify-center row style="display: inline-grid;">
                            <v-flex text-xs-center justify-right>
                                {{value.cardInfo}}
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex lg12 pa-0>
                        <v-layout justify-center row ma-0 pa-0>
                            <v-flex text-xs-end lg5 style="display: contents;">
                                <span class="caption">
                                    Real / Limite
                                </span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout justify-center row class="display-1" v-else>
                    <v-flex text-xs-center justify-center lg12 mb-5 style="display: -webkit-box;">
                        <span>
                            {{value.cardInfo}}
                        </span>
                    </v-flex>
                </v-layout>
                <v-expand-transition>
                    <v-layout v-if="hover && !large" class="d-flex transition-fast-in-fast-out v-card--reveal full-height" row justify-start 
                        align-center ml-1>
                        <v-list class="elevation-0">
                            <v-list-item v-for="i in value.hoverList" :key="i.text" :to="i.link">
                                <span class="caption mr-5">{{i.text}}</span>
                                <v-spacer />
                                <span class="body-1"> {{i.value}} </span>
                            </v-list-item>
                        </v-list>
                    </v-layout>
                    <v-layout v-if="hover && large" class="d-flex transition-fast-in-fast-out v-card--reveal full-height" row justify-start
                        align-center ml-1>
                        <v-list>
                            <v-list-item v-for="i in value.hoverList" :key="i.text" :to="i.link">
                                <span class="caption mr-5">{{i.text}}</span>
                                <v-spacer />
                                <span class="body-1"> {{i.value}} </span>
                            </v-list-item>
                        </v-list>
                    </v-layout>
                </v-expand-transition>                                    
            </v-list>
        </v-card>
    </v-hover>
</template>

<script>
    export default {
        props: {
            value: Object,
            title: String,
            large: {
                type: Boolean,
                default: false
            },
            marcador: {
                type: String,
                default: ''
            },
            mortalidade: {
                type: Boolean,
                default: false
            }
        },
        computed: {
        },
        data() {
            return {
                hover: true
            }
        }
    }
</script>

<style>
    .v-card--reveal {
        align-items: center;
        top: 0;
        justify-content: center;
        opacity: .9;
        position: relative;
        width: 97%;
    }

    .blink_me_small {
        animation-name: blinker-small;
        animation-direction: alternate;
        animation-duration: 0.7s;
        animation-fill-mode: both;
        animation-play-state: running;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: 25;
    }

    @keyframes blinker-small {
        0% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 2%);}
        5% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 3%);}
        10% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 4%);}
        15% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 5%);}
        20% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 6%);}
        25% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 7%);}
        30% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 8%);}
        35% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 9%);}
        40% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 10%);}
        45% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 11%);}
        50% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 12%);}
        55% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 13%);}
        60% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 14%);}
        65% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 15%);}
        70% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 16%);}
        75% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 17%);}
        80% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 18%);}
        85% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 19%);}
        90% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 20%);}
        95% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 21%);}
        100% {background: linear-gradient(to right, rgba(255, 0, 0, 0.5) 0%, rgba(16, 48, 61, 0) 22%);}
    }
</style>

